module.exports = __webpack_public_path__ + "static/konstancin-5ce8dfc35711379034c86355770a8733.png";